<template>
  <div class="container-fluid customer-events-container">
    <b-row class="mt-3">
      <b-col lg="6" class="mt-3 mx-auto">
        <h2 class="pageTitleH2DY">Book Live Stream Class</h2>
      </b-col>
    </b-row>
    <b-card no-body id="myEventsDYCard" class="mt-1 p-3 mb-5">
      <FullCalendar
        ref="fullCalendarEventsDY"
        :options="calendarOptions"
        :eventsources="calendarOptions.eventSources"
        :config="config"
      />
    </b-card>

    <b-modal
      id="bookPrivateClassModalDY"
      modal-class="book-class-modal-dy"
      size="sm"
      centered
      title="Book Class"
      title-class="modal-title-dy"
      no-close-on-esc
      no-close-on-backdrop
      @close="clickHeaderClose"
    >
      <b-row>
        <b-col
          ><b-input-group size="sm">
            <b-input-group-prepend class="mr-3">
              <img
                class=""
                src="@/assets/images/doom-yoga/calendar-icon-book.png"
                alt=""
              />
            </b-input-group-prepend>

            <p class="book-class-dy-date-p">{{ selected_date }}</p>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row class="mt-2"
        ><b-col>
          <b-form-group :slot="slot">
            <p class="error_validation_message_p_dy" v-if="invalid_slot">
              Please select slot
            </p>
            <b-input-group size="sm" class="w-100">
              <b-input-group-prepend class="mr-3">
                <img
                  class=""
                  src="@/assets/images/doom-yoga/clock-icon-book.png"
                  alt=""
                />
              </b-input-group-prepend>
              <v-select
                class="w-75"
                :options="slots_list"
                name="slot"
                title="slot"
                v-model="slot"
                :reduce="(item) => item.code"
                placeholder="Select slot"
                required
              ></v-select>
            </b-input-group> </b-form-group></b-col
      ></b-row>
      <b-row class="mt-2"
        ><b-col>
          <b-form-group :slot="slot">
            <p class="error_validation_message_p_dy" v-if="invalid_class">
              Please select class
            </p>
            <b-input-group size="sm" class="w-100">
              <b-input-group-prepend class="mr-3">
                <img
                  class=""
                  src="@/assets/images/doom-yoga/class-type-icon-book.png"
                  alt=""
                />
              </b-input-group-prepend>
              <v-select
                class="w-75"
                :options="classes_list"
                name="selected_class"
                title="selected_class"
                v-model="selected_class"
                :reduce="(item) => item.code"
                placeholder="Select class"
                required
              ></v-select>
            </b-input-group> </b-form-group></b-col
      ></b-row>

      <template class="mt-5" #modal-footer>
        <b-row class="justify-content-center w-100 mx-auto">
          <b-col cols="6" class="text-center">
            <b-button
              type="button"
              variant="doomyoga-primary"
              class="w-100 btn-bumblebee btn-doomyoga btn-doom-yoga-book"
              @click="clickConfirmBook"
            >
              Book
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
    <!-- modal book class / course -->

    <b-modal
      id="bookClassModalDY"
      modal-class="book-class-modal-dy"
      size="sm"
      centered
      title="Book Class"
      title-class="modal-title-dy"
      no-close-on-esc
      no-close-on-backdrop
    >
      <b-row>
        <b-col
          ><b-input-group size="sm">
            <b-input-group-prepend class="mr-3">
              <img
                class=""
                src="@/assets/images/doom-yoga/calendar-icon-book.png"
                alt=""
              />
            </b-input-group-prepend>

            <p class="book-class-dy-date-p">{{ selected_date }}</p>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row class="mt-2"
        ><b-col
          ><b-input-group size="sm">
            <b-input-group-prepend class="mr-3">
              <img
                class=""
                src="@/assets/images/doom-yoga/clock-icon-book.png"
                alt=""
              />
            </b-input-group-prepend>

            <p class="book-class-dy-date-p">{{ selected_event_time }}</p>
          </b-input-group>
        </b-col></b-row
      >
      <b-row class="mt-2"
        ><b-col>
          <b-input-group size="sm">
            <b-input-group-prepend class="mr-3">
              <img
                class=""
                src="@/assets/images/doom-yoga/class-type-icon-book.png"
                alt=""
              />
            </b-input-group-prepend>

            <p class="book-class-dy-date-p">{{ selected_event_title }}</p>
          </b-input-group>
        </b-col></b-row
      >
      <b-row class="mt-2"
        ><b-col>
          <b-input-group size="sm">
            <b-input-group-prepend class="mr-3">
              <img
                class=""
                src="@/assets/images/doom-yoga/location-icon.png"
                alt=""
              />
            </b-input-group-prepend>

            <p class="book-class-dy-date-p">{{ selected_event_location }}</p>
          </b-input-group>
        </b-col></b-row
      >

      <template class="mt-5" #modal-footer>
        <b-row class="justify-content-center w-100 mx-auto">
          <b-col cols="6" class="text-center">
            <b-button
              type="button"
              variant="doomyoga-primary"
              class="w-100 btn-bumblebee btn-doomyoga btn-doom-yoga-book"
              @click="clickConfirmBookEventClass"
            >
              Book
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- modal booked event -->

    <b-modal
      id="bookedEventModalDY"
      modal-class="book-class-modal-dy"
      size="sm"
      centered
      :title="booked_event.name"
      title-class="modal-title-dy"
      no-close-on-esc
      no-close-on-backdrop
    >
      <b-row>
        <b-col
          ><b-input-group size="sm">
            <b-input-group-prepend class="mr-3">
              <img
                class=""
                src="@/assets/images/doom-yoga/calendar-icon-book.png"
                alt=""
              />
            </b-input-group-prepend>

            <p class="book-class-dy-date-p">{{ booked_event.date }}</p>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row class="mt-2"
        ><b-col
          ><b-input-group size="sm">
            <b-input-group-prepend class="mr-3">
              <img
                class=""
                src="@/assets/images/doom-yoga/clock-icon-book.png"
                alt=""
              />
            </b-input-group-prepend>

            <p class="book-class-dy-date-p">{{ booked_event.time }}</p>
          </b-input-group>
        </b-col></b-row
      >
      <b-row class="mt-2"
        ><b-col>
          <b-input-group size="sm">
            <b-input-group-prepend class="mr-3">
              <img
                class=""
                src="@/assets/images/doom-yoga/class-type-icon-book.png"
                alt=""
              />
            </b-input-group-prepend>

            <p class="book-class-dy-date-p">{{ booked_event.name }}</p>
          </b-input-group>
        </b-col></b-row
      >
      <b-row class="mt-2"
        ><b-col>
          <b-input-group size="sm">
            <b-input-group-prepend class="mr-3">
              <img
                class=""
                src="@/assets/images/doom-yoga/location-icon.png"
                alt=""
              />
            </b-input-group-prepend>

            <p class="book-class-dy-date-p">{{ booked_event.address }}</p>
          </b-input-group>
        </b-col></b-row
      >

      <template class="mt-5" #modal-footer>
        <b-row class="justify-content-center w-100 mx-auto">
          <b-col class="text-center">
            <b-button
              type="button"
              disabled
              variant="doomyoga-primary"
              class="w-100 btn-bumblebee btn-doomyoga btn-doom-yoga-book"
            >
              Already booked
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";
import moment from "moment";

import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);

import "@fullcalendar/core/vdom"; // solves problem with Vite
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from "@fullcalendar/list";

export default {
  components: {
    FullCalendar, // make the <FullCalendar> tag available
  },

  data() {
    return {
      calendarOptions: {
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin],
        initialView: "dayGridMonth",
        // displayEventTime: true,
        headerToolbar: {
          // left: 'title',
          // left:'prev title next',
          // center: 'agendaDay,agendaWeek,month,agendaYear',
          // right:'today',
          left: "prev next title",
          center: "today",
          right: "dayGridMonth,timeGridWeek,timeGridDay",
          // center: 'agendaDay,agendaWeek,month',
          // right: 'prev,next today'
        },
        eventLimit: true,
        dayMaxEvents: 2,
        displayEventEnd: true,
        nowIndicator: true,
        navLinks: true,
        // Dynamic Event Source
        eventSources: [
          {
            events(start, callback) {
              console.log(start.start, start.end);
              if (window.localStorage.getItem("user") != null) {
                axios
                  .get("event/sessions-calendar", {
                    params: { from: start.start, to: start.end },
                    headers: {
                      Accept: "application/json",
                      "Content-Type": "application/json",
                      client: "DY",
                      Authorization:
                        "Bearer " +
                        JSON.parse(window.localStorage.getItem("user"))
                          .access_token,
                    },
                  })
                  .then((response) => {
                    console.log(response);
                    callback(response.data);
                  });
              } else {
                axios
                  .get("event/sessions-calendar", {
                    params: { from: start.start, to: start.end },
                    headers: {
                      Accept: "application/json",
                      "Content-Type": "application/json",
                      client: "DY",
                    },
                  })
                  .then((response) => {
                    console.log(response);
                    callback(response.data);
                  });
              }
            },
          },
          // {
          //   events(start, callback) {
          //     console.log(start.start, start.end);
          //     console.log(axios.defaults.baseURL);
          //     axios
          //       .get("events_test", { params: { start_date: start.start, end_date: start.end } })
          //       .then((response) => {
          //         console.log(response);
          //         callback(response.data.calendardata);
          //       });
          //   },
          // },
        ],
        initialDate: window.sessionStorage.getItem("initialDate"),
        events: [
          // {
          //   id: 4,
          //   title: "Yoga class",
          //   description: "Test yoga class",
          //   start: "2022-11-06T12:30:00",
          //   end: "2022-11-06T14:00:00",
          //   className: "classEvent",
          // },
          // {
          //   id: 5,
          //   title: "Course 1",
          //   description: "test description",
          //   start: "2022-11-13T06:00:00",
          //   end: "2022-11-13T10:00:00",
          //   className: "courseEvent",
          // },
          // {
          //   id: 6,
          //   title: "Class hellllo",
          //   description: "Yoga class ",
          //   start: "2022-11-06T16:00:00",
          //   end: "2022-11-06T19:00:00",
          //   className: "privateClassEvent",
          // },
          // {
          //   id: 12,
          //   title: "Course test test",
          //   description: "test course july",
          //   start: "2022-11-06T07:00:00",
          //   end: "2022-11-06T09:00:00",
          //   className: "privateClassEvent is-booked",
          // },
          // {
          //   id: 8,
          //   title: "Private class test test test",
          //   description: "",
          //   start: "2022-11-06T10:00:00",
          //   end: "2022-11-06T11:00:00",
          //   className: "privateClassEvent",
          // },
          // {
          //   id: 12,
          //   title: "Class test test",
          //   description: "hello",
          //   start: "2022-11-06T07:00:00",
          //   end: "2022-11-06T08:30:00",
          //   className: "privateClassEvent",
          // },
          // {
          //   id: 10,
          //   title: "class test test test",
          //   description: "class ",
          //   start: "2022-11-06T10:00:00",
          //   end: "2022-11-06T11:00:00",
          //   className: "classEvent",
          // },
        ],
        eventClick: (event) => {
          console.log("event");
          console.log(event);
          console.log(event.event.id);
          console.log(event.el.className);
          if (!event.el.className.includes("is-booked")) {
            let start = event.event.start,
              end = event.event.end;
            this.selected_date = moment(start).format("ddd, DD MMM YYYY");
            this.selected_event_time =
              moment(start).format("hh:mm a") +
              " - " +
              moment(end).format("hh:mm a");
            this.selected_event_title = event.event.title;
            this.selected_event_location =
              event.event._def.extendedProps.location;
            this.selected_event_id = event.event.id;
            this.$bvModal.show("bookClassModalDY");
          } else {
            // alert("already booked event");
            axios
              .get("event/session-event-details/" + event.event.id, {
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  client: "DY",
                  Authorization:
                    "Bearer " +
                    JSON.parse(window.localStorage.getItem("user"))
                      .access_token,
                },
              })
              .then((response) => {
                console.log(response);
                console.log(response.data);
                this.booked_event = response.data;
                // callback(response.data);
                this.$bvModal.show("bookedEventModalDY");
              });
          }
        },
        dateClick: function (info) {
          console.log(info);
          console.log("Clicked on: " + info.dateStr);
          console.log(
            "Coordinates: " + info.jsEvent.pageX + "," + info.jsEvent.pageY
          );
          console.log("Current view: " + info.view.type);
          // change the day's background color just for fun
          info.dayEl.style.backgroundColor = "rgba(215, 191, 188, 0.5)";
          this.selected_date = moment(info.dateStr).format("ddd, DD MMM YYYY");
          this.selected_date_cell = info.dayEl;
          this.slot = null;
          this.selected_class = null;
          this.$bvModal.show("bookPrivateClassModalDY");
        }.bind(this),
      },
      config: {},
      // form data
      selected_date: null,
      selected_date_cell: null,
      slots_list: [
        { label: "09:00 am - 10:00 am", code: "09:00 am - 10:00 am" },
        { label: "10:00 am - 11:00 am", code: "10:00 am - 11:00 am" },
        { label: "11:00 am - 12:00 pm", code: "11:00 am - 12:00 pm" },
        { label: "12:00 pm - 01:00 pm", code: "12:00 pm - 01:00 pm" },
        { label: "01:00 pm - 02:00 pm", code: "01:00 pm - 02:00 pm" },
        { label: "02:00 pm - 03:00 pm", code: "02:00 pm - 03:00 pm" },
        { label: "03:00 pm - 04:00 pm", code: "03:00 pm - 04:00 pm" },
        { label: "04:00 pm - 05:00 pm", code: "04:00 pm - 05:00 pm" },
        { label: "05:00 pm - 06:00 pm", code: "05:00 pm - 06:00 pm" },
        { label: "06:00 pm - 07:00 pm", code: "06:00 pm - 07:00 pm" },
        { label: "07:00 pm - 08:00 pm", code: "07:00 pm - 08:00 pm" },
        { label: "08:00 pm - 09:00 pm", code: "08:00 pm - 09:00 pm" },
      ],
      slot: null,
      invalid_slot: false,
      classes_list: [
        { label: "private class 1", code: 1 },
        { label: "1 to 1 class", code: 2 },
      ],
      selected_class: null,
      invalid_class: false,
      selected_event_time: null,
      selected_event_title: null,
      selected_event_description: null,
      selected_event_location: null,
      selected_event_id: null,
      booked_event: {},
    };
  },

  methods: {
    eventClick: (event) => {
      console.log(event);
    },
    clickConfirmBook() {
      console.log("click confirm book");
      console.log(this.selected_date, this.slot, this.selected_class);
      if (this.slot == null) {
        this.invalid_slot = true;
      } else {
        this.invalid_slot = false;
      }
      if (this.selected_class == null) {
        this.invalid_class = true;
      } else {
        this.invalid_class = false;
      }

      if (!this.invalid_class && !this.invalid_slot) {
        if (this.selected_date_cell != null) {
          this.selected_date_cell.style.backgroundColor = "transparent";
        }
        this.$bvModal.hide("bookPrivateClassModalDY");

        console.log(window.sessionStorage.getItem("selected_date"));
        window.sessionStorage.setItem("selected_date", this.selected_date);
        window.sessionStorage.setItem("selected_slot", this.slot);
        window.sessionStorage.setItem("selected_class", this.selected_class);
        window.sessionStorage.setItem("is_private_class", true);
        sessionStorage.removeItem("is_cancel");
        sessionStorage.removeItem("initialDate");
        console.log(window.sessionStorage.getItem("selected_date"));
        this.$router.push({ name: "DoOmYogaCustomerEventsBookSummary" });
      }
    },
    clickConfirmBookEventClass() {
      console.log("book class/course");
      console.log(this.selected_date);
      console.log(this.selected_event_id);

      window.sessionStorage.setItem("selected_date", this.selected_date);
      window.sessionStorage.setItem("selected_class", this.selected_event_id);
      window.sessionStorage.setItem("is_private_class", false);
      this.$bvModal.hide("bookClassModalDY");
      //
      this.$router.push({ name: "DoOmYogaCustomerEventsBookSummary" });
    },
    clickHeaderClose() {
      console.log("click close modal");
      if (this.selected_date_cell != null) {
        this.selected_date_cell.style.backgroundColor = "transparent";
      }
      sessionStorage.removeItem("is_cancel");
      sessionStorage.removeItem("initialDate");
    },
  },
  mounted() {
    console.log(this);
    console.log(window.sessionStorage);
    console.log(window.sessionStorage.getItem("is_cancel"));

    if (
      window.sessionStorage.getItem("is_cancel") != null &&
      window.sessionStorage.getItem("is_cancel") == "true"
    ) {
      this.selected_date = window.sessionStorage.getItem("selected_date");
      this.slot = window.sessionStorage.getItem("selected_slot");
      this.selected_class = parseInt(
        "" + window.sessionStorage.getItem("selected_class")
      );
      if (window.sessionStorage.getItem("is_private_class") == "true") {
        this.$bvModal.show("bookPrivateClassModalDY");
      } else {
        console.log(this.selected_class);
        console.log(this.selected_date);
        // this.$bvModal.show("bookClassModalDY");
      }

      // let calendarApi = this.$refs.fullCalendarEventsDY.getApi();
      // console.log(this.$refs.fullCalendarEventsDY)
      // console.log(calendarApi)
      // calendarApi.setOption('goToDate' , "2020-08-11")
      // calendarApi.goToDate("2020-08-11");
      //  sessionStorage.removeItem("is_cancel");
    } else {
      sessionStorage.removeItem("initialDate");
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/doom_yoga/customer/Events/Calendar.vue